
import { z } from "zod";

export const InvoicePartyValues = ["HOMEOWNER", "PARTNER"] as const;
export const InvoicePartySchema = z.enum(InvoicePartyValues);
export const InvoiceParty = InvoicePartySchema.enum;
export type InvoiceParty = (typeof InvoicePartyValues)[number];
export const InvoicePartyDisplayNames = { "HOMEOWNER": "Homeowner",
"PARTNER": "Partner", } satisfies Record<InvoiceParty, string>;
